/**
 * MiniWave — compact animated bars for live transmission indicators in ChannelList.
 */
import React from 'react';

const BARS = 5;

export default function MiniWave({ color = '#34C759', size = 14 }) {
  return (
    <div
      className="flex items-end gap-[2px] flex-shrink-0"
      style={{ height: size }}
      aria-label="transmitiendo"
    >
      {Array.from({ length: BARS }).map((_, i) => (
        <span
          key={i}
          style={{
            display: 'inline-block',
            width: 2,
            height: '100%',
            background: color,
            borderRadius: 1,
            transformOrigin: 'bottom',
            animationName: 'wave',
            animationDuration: `${0.55 + (i % 3) * 0.12}s`,
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            animationDelay: `${i * 0.07}s`,
            transform: 'scaleY(0.4)',
          }}
        />
      ))}
    </div>
  );
}
